module.exports = __webpack_public_path__ + "static/media/open_box.6b4c6351.webp";